import { getHash } from './getHash';

interface GetAvailabilityHashOptions {
    startDate: string;
    endDate: string;
    enterpriseId: string;
    voucherCode: string | undefined;
    startTimeUtc?: string;
    endTimeUtc?: string;
}

export const getAvailabilityHash = ({ startDate, endDate, enterpriseId, voucherCode }: GetAvailabilityHashOptions) =>
    getHash({
        startDate,
        endDate,
        enterpriseId,
        voucherCode,
    });
